var App;
(function (App) {
    var LegacyControls = /** @class */ (function () {
        function LegacyControls() {
        }
        return LegacyControls;
    }());
    App.LegacyControls = LegacyControls;
    LegacyControls.GridView = function (el, options) { return $(el).GridView(options); };
    LegacyControls.OpenDeleteDialog = function (entityId, idsToRemove, entitiesToDelete, callback, deleteFromDb) {
        $.agito.hrmPage.openDeleteDialog(entityId, idsToRemove, entitiesToDelete, callback, null, null, null, deleteFromDb);
    };
    LegacyControls.OpenQuickEditDialog = function (entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, callback, formGroupId, parameters) {
        $.agito.hrmPage.quickEditDialog(entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, callback, formGroupId, parameters);
    };
    LegacyControls.handleAjaxError = function (target, ajaxResponse, clearTarget) {
        var userMessagesContainer = target.closest(".hrm-page-placeholder, .modal-body, body").find(".hrm-page-messages-placeholder");
        $.agito.hrmPage.handleAjaxError(userMessagesContainer, ajaxResponse, clearTarget);
    };
    var LegacyUrlHelpers = /** @class */ (function () {
        function LegacyUrlHelpers() {
        }
        return LegacyUrlHelpers;
    }());
    App.LegacyUrlHelpers = LegacyUrlHelpers;
    LegacyUrlHelpers.OpenBrowserTab = function (url) { return UrlHelpers.OpenBrowserTab(url); };
    LegacyUrlHelpers.HrmPageLoadDialog =
        function (url, callback) { return $.agito.hrmPage.loadDialog(url, callback); };
})(App || (App = {}));
//# sourceMappingURL=legacy.js.map